import { Component, Input } from '@angular/core';
import { TranslatePipe } from '@ngx-translate/core';

export type DrawerHeaderAction = 'create' | 'edit' | 'view';

@Component({
  selector: 'siat-drawer-header',
   
  imports: [TranslatePipe],
  templateUrl: './drawer-header.component.html',
  styleUrl: './drawer-header.component.scss',
})
export class DrawerHeaderComponent {
  /**
   * The CRUD action type: create, edit, or view
   */
  @Input() action: DrawerHeaderAction = 'view';

  /**
   * Translation key for the entity name (e.g., 'RUOLI.singular', 'CONTESTI.singular')
   */
  @Input() entityTranslationKey = '';

  /**
   * Optional: specific item name to display (e.g., name of the role being edited)
   * Used for 'edit' and 'view' actions
   */
  @Input() itemName?: string;

  /**
   * Optional: custom title that overrides the default title generation
   * If provided, this will be used instead of action + entityTranslationKey
   */
  @Input() customTitle?: string;

  /**
   * Gets the translation key for the action
   */
  get actionTranslationKey(): string {
    switch (this.action) {
      case 'create':
        return 'CRUD.actions.create';
      case 'edit':
        return 'CRUD.actions.edit';
      case 'view':
        return 'CRUD.actions.details';
      default:
        return 'CRUD.actions.details';
    }
  }

  /**
   * Determines if the item name should be displayed
   */
  get shouldShowItemName(): boolean {
    return (this.action === 'edit' || this.action === 'view') && !!this.itemName;
  }
}
